import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getItems } from '../../../api/items';

import { mergeItemsListWithUserData } from '../../../utils/items';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';

import { NEXT_LINK } from '../constants/itemsHeaders';

export const fetchLayout = createAsyncThunk(
  'items/fetchLayout',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getItems(path, {
        cancelToken: source.token,
        params,
      });
      const [itemsResponse, userDataMapResponse] = response;
      return {
        data: mergeItemsListWithUserData(itemsResponse, userDataMapResponse),
        nextLink: itemsResponse.headers[NEXT_LINK] || null,
      };
    } catch (error) {
      return rejectWithValue(error.response?.status);
    }
  },
);

export const fetchLayoutExtraReducers = builder => {
  builder
    .addCase(fetchLayout.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.items.layouts.request,
        action,
        action.meta.arg.key,
      );
    })
    .addCase(fetchLayout.fulfilled, (state, action) => {
      const layoutKey = action.meta.arg.key;
      onMatchedRequest(state.items.layouts.request[layoutKey], action, () => {
        const { payload } = action;
        const isFirstPage = !action.meta.arg.params?.offset;
        const layout = state.items.layouts.byId[layoutKey];
        payload.data.items.forEach(item => {
          const itemCIDKey = generateItemCIDKey(item);
          state.items.item.byId[itemCIDKey] = item;
          state.items.layouts.paginationNext[layoutKey] = payload.nextLink;
          if (!state.items.item.allIds.includes(itemCIDKey))
            state.items.item.allIds.push(itemCIDKey);
        });
        if (!layout || isFirstPage) {
          state.items.layouts.byId[layoutKey] = payload.data.layout;
          return;
        }
        state.items.layouts.byId[layoutKey].push(...payload.data.layout);
      });
    })
    .addCase(fetchLayout.rejected, (state, action) => {
      handleRequestRejection(
        state.items.layouts.request[action.meta.arg.key],
        action,
      );
    });
};
